export const course = [
  {
    id: 1,
    name: "Introduction",
    resources: [7, 8, 9],
    objectives: [
      'To know what is JavaScript,its specification and how it is update',
      'To identify the necessary tools to create the right development environment',
      'To prepare and create a basic Web app'
    ]
  },
  {
    id: 2,
    name: "JavaScript Fundamentals",
    resources: [10, 11, 12, 13, 14, 15, 40, 41, 48, 49, 55, 56, 67],
  },
  {
    id: 3,
    name: "DOM",
    resources: [68, 69, 77, 78],
  },
  {
    id: 4,
    name: "Objects",
    resources: [],
  },
  {
    id: 5,
    name: "Classes",
    resources: [],
  },
  {
    id: 6,
    name: "Advanced Topics",
    resources: [],
  }

];


